(function () {
  var header = document.querySelector("[data-fcc-header]");
  var toggle = document.querySelector("[data-fcc-menu-toggle]");

  if (header && toggle) {
    toggle.addEventListener("click", function () {
      var isOpen = header.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    header.querySelectorAll(".fcc-nav__link").forEach(function (link) {
      link.addEventListener("click", function () {
        header.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  document.querySelectorAll("[data-fcc-tabs]").forEach(function (tabs) {
    var buttons = tabs.querySelectorAll("[data-fcc-tab]");
    var panels = tabs.querySelectorAll("[data-fcc-panel]");

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var selected = button.getAttribute("data-fcc-tab");

        buttons.forEach(function (candidate) {
          var isActive = candidate === button;
          candidate.classList.toggle("is-active", isActive);
          candidate.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute("data-fcc-panel") === selected;
          panel.classList.toggle("is-active", isActive);
          panel.hidden = !isActive;
        });
      });
    });
  });

  var revealItems = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window && revealItems.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });

    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add("is-visible");
    });
  }

  document.querySelectorAll("[data-fcc-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-fcc-main-image]");
    var thumbs = gallery.querySelectorAll("[data-fcc-thumb]");

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var nextSrc = thumb.getAttribute("data-src");
        var nextAlt = thumb.getAttribute("data-alt") || "";
        if (main && nextSrc) {
          main.setAttribute("src", nextSrc);
          main.setAttribute("alt", nextAlt);
        }
      });
    });
  });

  document.querySelectorAll(".fcc-product-page").forEach(function (productPage) {
    var variantSelect = productPage.querySelector('select[name="id"]');
    var gallery = productPage.querySelector("[data-fcc-gallery]");
    var mainImage = gallery ? gallery.querySelector("[data-fcc-main-image]") : null;
    var price = productPage.querySelector("[data-fcc-product-price]");
    var addToCart = productPage.querySelector("[data-fcc-add-to-cart]");

    if (!variantSelect) return;

    variantSelect.addEventListener("change", function () {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      if (!selected) return;

      var mediaSrc = selected.getAttribute("data-media-src");
      var mediaAlt = selected.getAttribute("data-media-alt") || "";
      var variantPrice = selected.getAttribute("data-variant-price");
      var isAvailable = selected.getAttribute("data-variant-available") === "true";

      if (mainImage && mediaSrc) {
        mainImage.setAttribute("src", mediaSrc);
        mainImage.setAttribute("alt", mediaAlt);

        productPage.querySelectorAll("[data-fcc-thumb]").forEach(function (thumb) {
          thumb.classList.toggle("is-active", thumb.getAttribute("data-src") === mediaSrc);
        });
      }

      if (price && variantPrice) {
        price.textContent = variantPrice;
      }

      if (addToCart) {
        addToCart.disabled = !isAvailable;
        addToCart.textContent = isAvailable ? "Add to cart" : "Sold out";
      }
    });
  });

  document.querySelectorAll("[data-fcc-preview-form]").forEach(function (form) {
    var success = form.querySelector("[data-fcc-form-success]");
    var submit = form.querySelector('button[type="submit"]');

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      if (success) {
        success.hidden = false;
        success.setAttribute("aria-live", "polite");
        if (typeof success.focus === "function") {
          success.focus({ preventScroll: true });
        }
      }

      if (submit) {
        submit.textContent = submit.getAttribute("data-success-text") || "Sent";
        submit.classList.add("is-confirmed");
      }
    });
  });

  var mockupIcons = {
    mountain: "M 18 55 L36 33 L47 44 L62 24 L88 55 M30 55 L46 43 M56 55 L68 41",
    star: "M53 22 L61 43 L84 43 L65 56 L72 78 L53 64 L34 78 L41 56 L22 43 L45 43 Z",
    bolt: "M58 19 L32 55 H52 L45 83 L76 44 H56 Z",
  };

  var mockupMaterials = {
    saddle: { label: "Saddle", background: "#b8733e", ink: "#25170f" },
    rawhide: { label: "Rawhide", background: "#d19a62", ink: "#2b1b12" },
    walnut: { label: "Walnut", background: "#6f3e27", ink: "#f5dfbf" },
    black: { label: "Black", background: "#1d1917", ink: "#f3d7a2" },
  };

  var defaultMockupState = {
    customerName: "HPG Customer",
    sampleInfo: "Richardson 112 / Heather Gray / Tan Mesh",
    patchText: "FRESH CATCH",
    patchSubtext: "CUSTOMS",
    material: "saddle",
    materialLabel: "Saddle",
    shape: "shield",
    icon: "mountain",
  };

  document.querySelectorAll("[data-fcc-mockup]").forEach(function (root) {
    var state = Object.assign({}, defaultMockupState);
    var fields = root.querySelectorAll(".js-fcc-mockup-field");
    var patch = root.querySelector("[data-fcc-mockup-patch]");
    var iconNode = root.querySelector(".js-fcc-patch-icon");
    var patchText = root.querySelector(".js-fcc-patch-text");
    var patchSubtext = root.querySelector(".js-fcc-patch-subtext");
    var proofCustomer = root.querySelector(".js-fcc-proof-customer");
    var proofSample = root.querySelector(".js-fcc-proof-sample");
    var copyButton = root.querySelector(".js-fcc-copy-spec");
    var resetButton = root.querySelector(".js-fcc-reset-mockup");
    var upload = root.querySelector(".js-fcc-logo-upload");

    function setSelected(selector, attribute, value) {
      root.querySelectorAll(selector).forEach(function (button) {
        button.classList.toggle("is-selected", button.getAttribute(attribute) === value);
      });
    }

    function renderIcon() {
      if (!iconNode || !mockupIcons[state.icon]) return;
      iconNode.innerHTML = '<svg viewBox="0 0 106 96" aria-hidden="true"><path d="' + mockupIcons[state.icon] + '"></path></svg>';
    }

    function renderMockup() {
      var material = mockupMaterials[state.material] || mockupMaterials.saddle;

      if (patchText) patchText.textContent = state.patchText || "YOUR LOGO";
      if (patchSubtext) patchSubtext.textContent = state.patchSubtext || "CUSTOM PATCH";
      if (proofCustomer) proofCustomer.textContent = state.customerName || "Customer name";
      if (proofSample) proofSample.textContent = state.sampleInfo || "Hat style / color / patch details";

      if (patch) {
        patch.classList.remove("fcc-patch-shield", "fcc-patch-rectangle", "fcc-patch-oval");
        patch.classList.add("fcc-patch-" + state.shape);
        patch.style.setProperty("--fcc-patch-bg", material.background);
        patch.style.setProperty("--fcc-patch-ink", material.ink);
      }
    }

    function resetUpload() {
      if (upload) upload.value = "";
      renderIcon();
    }

    fields.forEach(function (field) {
      field.addEventListener("input", function () {
        var key = field.getAttribute("data-field");
        if (!key) return;

        if (key === "patchText" || key === "patchSubtext") {
          state[key] = field.value.toUpperCase();
          field.value = state[key];
        } else {
          state[key] = field.value;
        }

        renderMockup();
      });
    });

    root.querySelectorAll("[data-material]").forEach(function (button) {
      button.addEventListener("click", function () {
        var materialKey = button.getAttribute("data-material") || "saddle";
        state.material = materialKey;
        state.materialLabel = button.getAttribute("data-label") || (mockupMaterials[materialKey] && mockupMaterials[materialKey].label) || "Saddle";
        setSelected("[data-material]", "data-material", materialKey);
        renderMockup();
      });
    });

    root.querySelectorAll("[data-shape]").forEach(function (button) {
      button.addEventListener("click", function () {
        state.shape = button.getAttribute("data-shape") || "shield";
        setSelected("[data-shape]", "data-shape", state.shape);
        renderMockup();
      });
    });

    root.querySelectorAll("[data-icon]").forEach(function (button) {
      button.addEventListener("click", function () {
        state.icon = button.getAttribute("data-icon") || "mountain";
        setSelected("[data-icon]", "data-icon", state.icon);
        resetUpload();
      });
    });

    if (upload && iconNode) {
      upload.addEventListener("change", function () {
        var file = upload.files && upload.files[0];
        if (!file) return;

        var reader = new FileReader();
        reader.onload = function () {
          iconNode.innerHTML = '<img src="' + reader.result + '" alt="">';
        };
        reader.readAsDataURL(file);
      });
    }

    if (copyButton) {
      copyButton.addEventListener("click", function () {
        var originalText = copyButton.getAttribute("data-original-text") || copyButton.textContent;
        var specText = [
          "Customer: " + state.customerName,
          "Sample: " + state.sampleInfo,
          "Patch: " + state.materialLabel + " " + state.shape,
          "Engraving: " + state.patchText + " / " + state.patchSubtext,
        ].join("\n");

        copyButton.setAttribute("data-original-text", originalText);

        if (!navigator.clipboard || !navigator.clipboard.writeText) {
          copyButton.textContent = "Copy unavailable";
          return;
        }

        navigator.clipboard.writeText(specText).then(function () {
          copyButton.textContent = "Specs Copied";
          window.setTimeout(function () {
            copyButton.textContent = originalText;
          }, 1800);
        }).catch(function () {
          copyButton.textContent = "Copy unavailable";
        });
      });
    }

    if (resetButton) {
      resetButton.addEventListener("click", function () {
        state = Object.assign({}, defaultMockupState);
        fields.forEach(function (field) {
          var key = field.getAttribute("data-field");
          if (key) field.value = state[key] || "";
        });
        setSelected("[data-material]", "data-material", state.material);
        setSelected("[data-shape]", "data-shape", state.shape);
        setSelected("[data-icon]", "data-icon", state.icon);
        resetUpload();
        renderMockup();
      });
    }

    renderIcon();
    renderMockup();
  });
})();
